import * as React from "react";
import {cx} from "emotion";

import "./time-picker-2.scss";

import {cs}          from "../../react/chain-services";
import {keyed}       from "../../react/keyed";
import {Static2}     from "../../react/static-2";
import {createArray} from "../../utils/collections";
import {paddingLeft} from "../../utils/strings";

import {formatTime11} from "./format-time-11";
import {parseTime}    from "./parse-time";

/**
 * This is different from <input type="time"/> as this go with
 */
export const TimePicker2 = ({state, className=undefined, hasError=false, onClick=undefined}) => cs(
    ["selectRef", (_, next) => Static2({next})],
    ({selectRef}) => (
        <div
            className={cx("time-picker time-picker-2-4r1", className, {hasError})}
            xd-qa-type="label" xd-qa-name={"Select Time"}
            onClick={() => {
                selectRef.get().click();
                onClick?.();
            }}
        >
            <div className="value">
                {/*{"09:00"}*/}
                {!state.value ? "--:--" : formatTime11(parseTime(state.value))}
            </div>
            <select
                ref={selectRef.set}
                value={state.value}
                onChange={(e) => state.onChange(e.target.value)}
                xd-qa-type="dropdown" xd-qa-name={"Select Time"}
            >
                {createArray(24*2).map((i) => cs(
                    keyed(i),
                    ["hour", (_, next) => next(Math.floor(i / 2))],
                    ["minute", (_, next) => next(i % 2 * 30)],
                    ({hour, minute}) => (
                        <option
                            value={paddingLeft(hour) + ":" + paddingLeft(minute)}

                            xd-qa-type="dropdown_item" xd-qa-name={formatTime11({hour, minute})}
                        >
                            {formatTime11({hour, minute})}
                        </option>
                    )
                ))}
            </select>

            {/*<img src={require("./clock.png")}/>*/}
            <i className="fa fa-clock-o"/>
        </div>
    ),
);


